(function() {
  // Quantity +/- controls
  document.addEventListener('click', function(e) {
    const minus = e.target.closest('[data-qty-minus]');
    const plus  = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;

    const wrap = (minus || plus).closest('[data-qty]');
    if (!wrap) return;
    const input = wrap.querySelector('[data-qty-input]');
    if (!input) return;

    const current = parseInt(input.value || '1', 10);
    if (minus) input.value = Math.max(1, current - 1);
    if (plus)  input.value = Math.max(1, current + 1);
  });

  // Add to cart
  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    let card = btn.closest('.product-card');
    if (!card) {
      card = btn.closest('.bundle-item');
    }
    if(!card) return;

    const variantId = card.getAttribute('data-variant-id');
    if (!variantId) {
      console.warn('No variant id on product card');
      return;
    }
    const audienceType = card.getAttribute('data-audience-type') || 'B2C';

    const qtyInput = card.querySelector('[data-qty-input]');
    const quantity = Math.max(1, parseInt(qtyInput?.value || '1', 10));

    btn.disabled = true;
    const originalText = btn.innerHTML;
    btn.classList.add('is-loading');
    btn.textContent = 'Toegevoegd...';

    try {
      // POST to Shopify AJAX cart
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity, properties: { "_audience_type": audienceType } }] })
      });

      if (!res.ok) throw new Error('Add to cart failed');
      const data = await res.json();

      // fire the custom event so your modal listener runs
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: {
          added: data,
          quantity: parseInt(quantity),
          id: variantId,
          audienceType: audienceType
        }
      }));

      btn.textContent = 'Toegevoegd!';
      setTimeout(() => {
        btn.innerHTML = originalText;
        btn.disabled = false;
        btn.classList.remove('is-loading');
      }, 1200);

    } catch (err) {
      console.error(err);
      btn.textContent = 'Mislukt, probeer opnieuw';
      setTimeout(() => {
        btn.innerHTML = originalText;
        btn.disabled = false;
        btn.classList.remove('is-loading');
      }, 1600);
    }
  });
})();